import config from "../config";
import axios from "axios";
import router from '../Routes';

export default {
  namespaced: true,
  state: {
    isFetchings: false,
    errorMessage: ''
  },
  mutations: {
    REPORT_REQUEST(state) {
      state.isFetching = true;
    },
    REPORT_SUCCESS(state, payload) {
      state.report = payload;
      state.isFetching = false;
      state.errorMessage = '';
    },
    REPORT_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
    },
  },
  actions: {
    getReport({dispatch}, payload) {
      if (!config.isBackend) {
        router.push('/Airdna/Report');
      } else {
        dispatch('requestReport');
        axios.get(config.aidnaApi +
          "/rentalizer/estimate?access_token=" + config.airdnaClientToken +
          "&address=" + payload.address +
          "&bedrooms=" + payload.beds +
          "&bathrooms=" + payload.baths +
          "&accommodates=" + payload.guests +
          "&show_urls=True").then(res => {
          dispatch('receiveReport', res.data);
        }).catch(err => {
          dispatch('reportError', err.response.data);
        })
      }
    },
    requestReport({commit}) {
      commit('REPORT_REQUEST');
    },
    receiveReport({commit}) {
      commit('REPORT_SUCCESS');
    },
    reportError({commit}, payload) {
      commit('REPORT_FAILURE', payload);
    },
  },
}
